import { render, staticRenderFns } from "./ServiceContent.vue?vue&type=template&id=3b462b71&scoped=true&"
import script from "./ServiceContent.vue?vue&type=script&lang=js&"
export * from "./ServiceContent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceContent.vue?vue&type=style&index=0&id=3b462b71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b462b71",
  null
  
)

export default component.exports